import { Modal, Stack, Text, Button, Image, Center, Box, Group, ActionIcon } from "@mantine/core"
import { useDisclosure } from "@mantine/hooks"
import { PUBLIC_URL } from "../utils/const"
import { useTranslation } from "react-i18next"
import { useEffect } from "react"
import { IconCross, IconX } from "@tabler/icons-react"

export const ScopeErrorModal = ({ defaultOpened }: { defaultOpened: boolean }) => {
    const { t } = useTranslation(['app']);
    const [opened, { open, close }] = useDisclosure(false)

    useEffect(() => {
        if (defaultOpened) {
            open()
        }
    }, [])

    return (
        <>
            <Modal.Root opened={opened} onClose={close} size="xl" visibleFrom="sm" transitionProps={{ duration: 500, transition: 'fade-up' }}>
                <Modal.Overlay />
                <Modal.Content>
                    <Modal.Header bg='red.0'>
                        <Modal.Title><Text fw='bold'>{t('scope_error.title')}</Text></Modal.Title>
                        <Modal.CloseButton onClick={close} />
                    </Modal.Header>
                    <Modal.Body>
                        <Stack mt='xl'>
                            <Text>{t('scope_error.description')}</Text>
                            <Center>
                                <Image src={`${PUBLIC_URL}/assets/google-scope-laptop.png`} alt="Scope Error" />
                            </Center>
                            <Button onClick={close}>{t('scope_error.close')}</Button>
                        </Stack>
                    </Modal.Body>
                </Modal.Content>
            </Modal.Root>
            <Modal.Root opened={opened} hiddenFrom="sm" fullScreen onClose={close} transitionProps={{ duration: 500, transition: 'fade-up' }}>
                <Modal.Overlay />
                <Modal.Content>
                    <Modal.Header bg='red.0'>
                        <Modal.Title><Text fw='bold'>{t('scope_error.title')}</Text></Modal.Title>
                        <Modal.CloseButton onClick={close} />
                    </Modal.Header>
                    <Modal.Body>
                        <Stack mt='xl'>
                            <Text>{t('scope_error.description')}</Text>
                            <Center>
                                <Image maw={'300'} src={`${PUBLIC_URL}/assets/google-scope-phone.png`} alt="Scope Error" />
                            </Center>
                            <Button onClick={close}>{t('scope_error.close')}</Button>
                        </Stack>
                    </Modal.Body>
                </Modal.Content>
            </Modal.Root>
        </>
    )
}